import * as salaryConstant from './constants'

const initialState = {
  list: [],
  listNVKD: [],
  listEXP: [],
  item: {},
  type: salaryConstant.SALARY_REPORT_DETAIL_LIST_INITING,
  listRequesting: false,
  requesting: false,
  successful: false,
  messages: [],
  errors: [],
}

const reducer = function productsReducer(state = initialState, action) {
  switch (action.type) {
    case salaryConstant.SALARY_REPORT_DETAIL_NVKD_REQUESTING:
      return {
        ...state,
      }

    case salaryConstant.SALARY_REPORT_DETAIL_NVKD_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        listNVKD: action.payload,
      }

    case salaryConstant.SALARY_REPORT_DETAIL_NVKD_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
      }
    case salaryConstant.SALARY_REPORT_DETAIL_LIST_REQUESTING:
      return {
        ...state,
        type: action.type,
        listRequesting: true,
        requesting: false,
        successful: false,
        messages: [{
          body: 'Đang tải dữ liệu...!',
          time: new Date(),
        }],
        errors: [],
      }

    case salaryConstant.SALARY_REPORT_DETAIL_LIST_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        list: action.payload.records,
        item: action.payload,
        listRequesting: false,
        requesting: false,
        successful: true,
        messages: [],
        errors: [],
      }

    case salaryConstant.SALARY_REPORT_DETAIL_LIST_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listRequesting: false,
        requesting: false,
        successful: false,
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }
    case salaryConstant.SALARY_REPORT_DETAIL_EXPORT_XLS_REQUESTING:
      return {
        ...state,
        type: action.type,
        formData: action.payload,
        callback: action.callback,
      }

    case salaryConstant.SALARY_REPORT_DETAIL_EXPORT_XLS_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listEXP: action.payload,
      }

    case salaryConstant.SALARY_REPORT_DETAIL_EXPORT_XLS_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
      }
    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/views/Reports/SalaryReportDetail/reducer.js